import { AgentPortal } from '@wallet-manager/pfh-pmp-node-def-types';

import axios from '../axiosInstance';
import { IlistResult } from '../types';

const balanceTab = {
  getAll: async (params: any, config?: any) => {
    const { pageSize, page, ...rest } = params;

    const input = {
      params: {
        ...rest,
        limit: pageSize,
        offset: pageSize * page,
      },
      ...config,
    };

    return await axios.get<any, IlistResult<any>>(
      AgentPortal.EPtDaManagement.walletBalance.getAll,
      input
    );
  },
  getExport: async (params: any, config?: any) => {
    const { pageSize, page, ...rest } = params;

    const input = {
      params: {
        ...rest,
        limit: pageSize,
        offset: pageSize * page,
      },
      ...config,
    };

    return await axios.get<any, IlistResult<any>>(
      AgentPortal.EPtDaManagement.walletBalance.export,
      input
    );
  },
};

const historyTab = {
  getAll: async (params: any, config?: any) => {
    const { pageSize, page, ...rest } = params;

    const input = {
      params: {
        ...rest,
        limit: pageSize,
        offset: pageSize * page,
      },
      ...config,
    };

    return await axios.get<any, IlistResult<any>>(
      AgentPortal.EPtDaManagement.walletBalanceHistory.getAll,
      input
    );
  },
  getExport: async (params: any, config?: any) => {
    const { pageSize, page, ...rest } = params;

    const input = {
      params: {
        ...rest,
        limit: pageSize,
        offset: pageSize * page,
      },
      ...config,
    };

    return await axios.get<any, IlistResult<any>>(
      AgentPortal.EPtDaManagement.walletBalanceHistory.export,
      input
    );
  },
};

export default { balanceTab, historyTab };
